// extracted by mini-css-extract-plugin
module.exports = {"verified":"icons_verified__NSM5V"};